
import { Colors } from '@brg/ui';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CreateLinkTo } from 'shared/constants/linkTo';
import styled from 'styled-components';
import {LayoutConst} from "../../../../core";

const OpaButtonWrapper = styled.span`

  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  transition: 0.2s all;
  
    a {
      transition: 0.2s all;
      color: ${Colors.galBlack47}
    }
    svg {
        margin-left: 4px;
      path {
        transition: 0.2s all;
        fill: ${Colors.galBlack47}
      }
    }
  
  &:hover {
    a {
      color: ${Colors.galBlack100}
    }
    svg {
      path {
        fill: ${Colors.galBlack100}
      }
    }
  }
  
  
  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 13px;
    line-height: 16px;
    white-space: nowrap;
  }
  
`;

interface IProps {
    id: string;
}

const DesignerOPAButton: FC<IProps> = ({ id }) => {
    const { t } = useTranslation();
    return (
        <OpaButtonWrapper>
            <Link to={CreateLinkTo.opaSearch(id)}>{t('opa_btn_text')}</Link>
            <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.55788 10.06L0.284091 8.78622L6.6772 2.38707H1.82351L1.83558 0.636363H9.70171V8.50852H7.93892L7.951 3.66087L1.55788 10.06Z" fill="#909090"/>
            </svg>
       </OpaButtonWrapper>
    )
}

export default React.memo(DesignerOPAButton);
import { Colors } from '@brg/ui';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CreateLinkTo } from 'shared/constants/linkTo';
import styled from 'styled-components';
import {LayoutConst} from "../../../../core";

const OpaButtonWrapper = styled.span`

  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.02em;
  transition: 0.2s all;
  
    a {
      transition: 0.2s all;
      color: ${Colors.galBlack47}
    }
    svg {
        margin-left: 4px;
      path {
        transition: 0.2s all;
        fill: ${Colors.galBlack47}
      }
    }
  
  &:hover {
    a {
      color: ${Colors.galBlack100}
    }
    svg {
      path {
        fill: ${Colors.galBlack100}
      }
    }
  }
  
  
  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 13px;
    line-height: 16px;
    white-space: nowrap;
  }
  
`;

interface IProps {
    id: string;
}

const DesignerOPAButton: FC<IProps> = ({ id }) => {
    const { t } = useTranslation();
    return (
        <OpaButtonWrapper>
            <Link to={CreateLinkTo.opaSearch(id)}>{t('opa_btn_text')}</Link>
            <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.55788 10.06L0.284091 8.78622L6.6772 2.38707H1.82351L1.83558 0.636363H9.70171V8.50852H7.93892L7.951 3.66087L1.55788 10.06Z" fill="#909090"/>
            </svg>
       </OpaButtonWrapper>
    )
}

export default React.memo(DesignerOPAButton);